module.exports = __webpack_public_path__ + "static/media/20ECE18.96545645.jpg";